import React, { useEffect } from 'react';

const BitmediaAd = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://cdn.bmcdn6.com/js/655b7ecd4dc6884594850d7d.js?v=' + new Date().getTime();

        script.onerror = () => {
            script.remove();
            // Xử lý lỗi nếu cần thiết
        };

        const insElement = document.getElementById('bitmedia');

        if (insElement) {
            insElement.appendChild(script);
        } else {
            console.error('Không tìm thấy phần tử với id là "bitmedia".');
        }

        return () => {
            // Thực hiện các tác vụ cleanup khi cần thiết
        };
    }, []); // Chạy useEffect chỉ một lần sau khi component mount

    return (
        <>
            <div className="flex flex-wrap  justify-center mb-1 mt-1">
                <ins id="bitmedia" className="655b7ecd4dc6884594850d7d" style={{ display: 'inline-block', width: '1px', height: '1px' }}>
                    {/* Bạn có thể thêm nội dung dự phòng ở đây nếu cần */}
                </ins>
            </div>


        </>

    );
};

export default BitmediaAd;
